<template>
    <div class="card-box">
        <div class="title-wrap">
            <span class="num">{{ idx }}</span>
            <div class="title">{{ title }}</div>
        </div>
        <div class="list-wrap">
            <ul>
                <li v-for="(item, idx) in list" :key="idx" v-html="item"></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        idx: {},
        list: {},
        title: {},
    },
};
</script>
<style lang="scss" scoped>
.card-box {
    background: var(--gray2);
    padding: 60px 50px;
    width: 100%;
    flex: 1 0 370px;
    min-height: 452px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 0;
    transition: 0.3s ease-in-out;
    position: relative;

    .num {
        font-family: 'Play', sans-serif;
        font-size: 22px;
        line-height: 1;
        color: #111;
        letter-spacing: -0.025em;
        font-weight: 700;
        display: inline-block;
        margin-bottom: 30px;
    }

    .title {
        font-family: 'Pretendard', sans-serif;
        font-weight: 700;
        color: var(--red);
        font-size: 28px;
        line-height: 1;
        letter-spacing: -0.025em;
        margin-bottom: 65px;

        @media screen and (max-width: 768px) {
            font-size: 24px;
        }
    }

    .list-wrap ul li {
        position: relative;
        list-style: none;
        letter-spacing: -0.025em;
        padding-left: 12px;
        color: #333;
        font-weight: 500;
        font-family: 'Pretendard', sans-serif;
        word-break: keep-all;
        @media screen and (max-width: 768px) {
            font-size: 14px;
        }

        & + li {
            margin-top: 10px;
        }

        &::after {
            position: absolute;
            content: '';
            width: 4px;
            height: 4px;
            background: #ccc;
            top: calc(1ch - 2px);
            left: 0;
        }
    }

    @media screen and (max-width: 1280px) {
        flex: 1 0 auto;
    }

    @media screen and (max-width: 768px) {
        min-height: 0;

        .title {
            margin-bottom: 28px !important;
        }
    }
}
</style>
